import { render, staticRenderFns } from "./ShopCategoriesHorizontal.vue?vue&type=template&id=7325e88a"
import script from "./ShopCategoriesHorizontal.vue?vue&type=script&lang=js"
export * from "./ShopCategoriesHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ShopCategoriesHorizontal.vue?vue&type=style&index=0&id=7325e88a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7325e88a')) {
      api.createRecord('7325e88a', component.options)
    } else {
      api.reload('7325e88a', component.options)
    }
    module.hot.accept("./ShopCategoriesHorizontal.vue?vue&type=template&id=7325e88a", function () {
      api.rerender('7325e88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopCategoriesHorizontal.vue"
export default component.exports